export const parseCurrency = (str) => {
  if (str === undefined || str === null) return NaN;
  
  const strValue = str.toString();
  
  // Boş string kontrolü
  if (strValue.trim() === '') return NaN;
  
  // Eğer sadece tam sayı ise (formatting olmamış) direkt parse et
  // NOT: Binlik ayırıcı noktaları olan sayıları yakalamamak için
  // sadece nokta OLMAYAN sayıları veya son 3 haneden az ondalık kısmı olan sayıları kabul et
  if (/^\d+$/.test(strValue)) {
    // Sadece rakamlar (6500, 1000, etc.)
    return parseFloat(strValue);
  }
  
  // Amerikan formatı kontrolü: sadece 1-2 ondalık basamaklı (6.5, 6.50)
  // Türkçe binlik ayırıcı ile karışmasın diye 3 haneden az ondalık kabul et
  if (/^\d+\.\d{1,2}$/.test(strValue)) {
    return parseFloat(strValue);
  }
  
  // Türkçe format kontrolü: nokta binlik ayırıcı, virgül ondalık
  // Örnek: "8.000,50" -> 8000.50
  // Örnek: "8.000" -> 8000
  // Örnek: "8000,50" -> 8000.50
  
  // Son virgülden sonraki kısım ondalık kısmıdır
  const parts = strValue.split(',');
  
  if (parts.length === 1) {
    // Virgül yok, sadece tam sayı kısmı
    const integerPart = parts[0].replace(/\./g, ''); // Noktaları kaldır
    return parseFloat(integerPart);
  } else if (parts.length === 2) {
    // Virgül var, ondalık kısım var
    const integerPart = parts[0].replace(/\./g, ''); // Noktaları kaldır
    const decimalPart = parts[1];
    
    // Ondalık kısmı maksimum 2 basamak olmalı
    const limitedDecimal = decimalPart.slice(0, 2);
    
    return parseFloat(`${integerPart}.${limitedDecimal}`);
  } else {
    // Birden fazla virgül var, hatalı format
    return NaN;
  }
};

export const formatCurrency = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const num = typeof value === 'number' ? value : parseCurrency(value);
  if (isNaN(num)) return value;
  
  // Türkçe formatta: 50.000,00 (nokta binlik ayırıcı, virgül ondalık ayırıcı)
  return num.toLocaleString('tr-TR', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
};

// Live formatting for input fields - formats as user types
export const formatCurrencyInput = (value) => {
  if (value === undefined || value === null || value === '') return '';
  
  // Sadece rakam, nokta ve virgül bırak
  const cleaned = value.toString().replace(/[^0-9.,]/g, '');
  
  // Eğer boşsa boş döndür
  if (cleaned === '') return '';
  
  // Virgül varsa ondalık kısmı ayır
  const parts = cleaned.split(',');
  const integerPart = parts[0] || '';
  const decimalPart = parts[1] || '';
  
  // Tam sayı kısmından noktaları kaldır ve binlik ayırıcı ekle
  const cleanInteger = integerPart.replace(/\./g, '');
  if (cleanInteger === '') return '';
  
  // Binlik ayırıcı ekleme
  const formattedInteger = cleanInteger.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  // Ondalık kısım varsa birleştir
  if (parts.length > 1) {
    return formattedInteger + ',' + decimalPart.slice(0, 2); // Maksimum 2 ondalık basamak
  }
  
  return formattedInteger;
};

// Tarih formatını gün/ay/yıl şekline çeviren yardımcı fonksiyon
export const formatDateDisplay = (dateString) => {
  if (!dateString) return "Belirtilmemiş";
  
  try {
    // YYYY-MM-DD formatını DD/MM/YYYY formatına çevir
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Geçersiz tarih ise olduğu gibi döndür
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    return dateString; // Hata durumunda orijinal değeri döndür
  }
}; 